<header class="header">
  <!-- Lewa strona - Nazwa bieżącej strony -->
  <div class="header-left">
    <!-- Nazwa bieżącej strony -->
    <button mat-icon-button (click)="toggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="current-page">
      <mat-icon class="page-icon">{{ currentPage.icon }}</mat-icon>
      <span class="page-title">{{ currentPage.title }}</span>
    </div>
  </div>

  <!-- Prawa strona - Akcje i użytkownik -->
  <div class="header-right">
    <!-- Powiadomienia -->
    <div class="notifications-section">
      <button mat-icon-button [matMenuTriggerFor]="notificationsMenu" class="notifications-button"
        [matBadge]="unreadCount > 0 ? unreadCount : null" matBadgeColor="warn" [matTooltip]="'header.notifications' | translate">
        <mat-icon>notifications</mat-icon>
      </button>

      <mat-menu #notificationsMenu="matMenu" class="notifications-menu">
        <div class="notifications-header">
          <h3>{{ 'header.notifications' | translate }}</h3>
          @if (unreadCount > 0) {
          <button mat-button color="primary" (click)="markAllAsRead()">
            {{ 'header.markAllRead' | translate }}
          </button>
          }
        </div>

        @if (notifications.length > 0) {
        <div class="notifications-list">
          @for (notification of notifications; track notification.id) {
          <div class="notification-item" [class.unread]="!notification.read" role="button" tabindex="0"
            (click)="markNotificationAsRead(notification.id)" (keyup.enter)="markNotificationAsRead(notification.id)"
            (keyup.space)="markNotificationAsRead(notification.id)">
            <div class="notification-icon">
              <mat-icon [color]="getNotificationColor(notification.type)">
                {{ getNotificationIcon(notification.type) }}
              </mat-icon>
            </div>
            <div class="notification-content">
              <div class="notification-title">{{ notification.title }}</div>
              <div class="notification-message">{{ notification.message }}</div>
              <div class="notification-time">
                {{ formatTimestamp(notification.timestamp) }}
              </div>
            </div>
            @if (!notification.read) {
            <div class="notification-status">
              <div class="unread-indicator"></div>
            </div>
            }
          </div>
          }
        </div>
        } @else {
        <div class="no-notifications">
          <mat-icon>notifications_none</mat-icon>
          <p>{{ 'header.noNotifications' | translate }}</p>
        </div>
        }
      </mat-menu>
    </div>

    <!-- Sekcja użytkownika -->
    <div class="user-section">
      @if(user()){
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div class="user-button__label">
          <div class="user-avatar">
            <img src="https://randomuser.me/api/portraits/women/44.jpg" [alt]="user()!.unique_name"
              class="avatar-image" />
            <div class="user-status-indicator"></div>
          </div>
          <div class="user-info">
            <div class="user-name" [title]="user()!.unique_name">{{ user()!.unique_name }}</div>
          </div>
        </div>
        <mat-icon class="dropdown-icon" iconPositionEnd>expand_more</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu" class="user-menu">
        <div class="user-menu-header">
          <div class="user-menu-avatar">
            <img src="https://randomuser.me/api/portraits/women/44.jpg" [alt]="user()!.unique_name" />
          </div>
          <div class="user-menu-info">
            <div class="user-menu-name" [title]="user()!.unique_name">
              {{ user()!.unique_name }}
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>

        <button mat-menu-item>
          <mat-icon>person</mat-icon>
          <span>{{ 'header.myProfile' | translate }}</span>
        </button>

        <button mat-menu-item (click)="openSettings()">
          <mat-icon>settings</mat-icon>
          <span>{{ 'header.settings' | translate }}</span>
        </button>

        <button mat-menu-item>
          <mat-icon>help</mat-icon>
          <span>{{ 'header.help' | translate }}</span>
        </button>

        <mat-divider></mat-divider>

        <button mat-menu-item (click)="logout()" class="logout-menu-item">
          <mat-icon>logout</mat-icon>
          <span>{{ 'header.logout' | translate }}</span>
        </button>
      </mat-menu>
      }
    </div>
  </div>
</header>